import {
    AppBar,
    Box,
    Container,
    useTheme,
    Typography,
    Grid
} from "@mui/material";
import { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";

import { useTypedSelector } from "../../hooks/useTypedSelector";
import { useActions } from "../../hooks/useActions";

import LinkRouter from "../../components/LinkRouter";

import { logo } from "../../assets/logos";
import { instagram, telegram } from "../../assets/icons";

import { DonationButtonStyle, SelectedTypographyStyle, TypographyStyle } from "./styled";
import HeaderDropdownMenu from "../../components/HeaderDropdownMenu";
import React from "react";
import HeaderMenu from "../../components/HeaderMenu";
import { donate, inst, tg } from "../../assets/links";
import DonateDialog from "../../components/DonateDialog/DonateDialog";


export interface IAppBarItem {
    lable: string,
    path: string,
}

const Header = () => {
    const { palette } = useTheme();
    const navigate = useNavigate();
    const location = useLocation();

    const [donateOpen, setDonateOpen] = useState<boolean>(false);

    const [pages, setPages] = useState<Array<IAppBarItem>>([
        { lable: 'Головна', path: '/' },
        { lable: 'Про нас', path: '/about-us' },
        { lable: 'Анонси', path: '/announcements' },
        { lable: 'Проєкти', path: '/projects' },
        { lable: 'Як відбувається захід?', path: '/how-is-event-going' },
        { lable: 'Контакти', path: '/contacts' },
    ]);

    return (
        <>
            <AppBar component="header" elevation={0} position="static" sx={{ minWidth: "100%", height: { xs: "80px", lg: "64px" }, borderBottom: (theme) => `1px solid ${theme.palette.primary.light}` }}>
                <Container sx={{ height: "100%", maxWidth: { lg: "1310px", md: "744px", xs: "350px" } }}>
                    <Grid container columns={{ xs: 4, md: 5, lg: 12 }} spacing={0} sx={{ height: "100%", display: "flex", alignItems: "center" }}>
                        <Grid item xs={2} lg={3}>
                            <LinkRouter underline="none" color="unset" to="/" sx={{ display: "flex", width: { xs: "157px", md: "200px" }, height: { xs: "26px", md: "34px" } }}>
                                <img
                                    loading="eager"
                                    style={{ width: "inherit", height: "inherit" }}
                                    src={logo}
                                    alt="logo"
                                />
                            </LinkRouter>
                        </Grid>
                        <Grid item lg={6} sx={{ display: { xs: 'none', lg: 'flex' }, justifyContent: "space-between" }}>
                            {pages.map((page, index) => (
                                <React.Fragment key={`header_item_${index}`}>
                                    {(index !== 3)
                                        ? <LinkRouter underline="none" color="inherit" to={page.path}>
                                            {(location.pathname === page.path || location.pathname.startsWith(`${page.path}/`))
                                                ? <SelectedTypographyStyle>
                                                    {page.lable}
                                                </SelectedTypographyStyle>
                                                : <TypographyStyle>
                                                    {page.lable}
                                                </TypographyStyle>
                                            }
                                        </LinkRouter>
                                        : <HeaderDropdownMenu {...page} />
                                    }
                                </React.Fragment>
                            ))}
                        </Grid>
                        <Grid item md={1} sx={{ display: { xs: 'none', md: 'block' } }} />
                        <Grid item xs={2}>
                            <Box sx={{ width: { md: "245px", lg: "207px" }, display: 'flex', justifyContent: { xs: "end", md: "space-between" }, ml: "auto" }}>
                                <DonationButtonStyle onClick={() => { setDonateOpen(true) }}>
                                    ДОНАТ
                                </DonationButtonStyle>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <Box sx={{ display: { xs: "none", md: "block" }, width: "24px", height: "24px", marginRight: "12px", cursor: "pointer" }} onClick={() => { window.open(inst) }}>
                                        <img
                                            loading="eager"
                                            src={instagram}
                                            alt="instagram"
                                            style={{ width: "inherit", height: "inherit", cursor: "pointer" }}
                                        />
                                    </Box>
                                    <Box sx={{ display: { xs: "none", md: "block" }, width: "24px", height: "24px", cursor: "pointer" }} onClick={() => { window.open(tg) }}>
                                        <img
                                            loading="eager"
                                            src={telegram}
                                            alt="telegram"
                                            style={{ width: "inherit", height: "inherit", cursor: "pointer" }}
                                        />
                                    </Box>
                                    <HeaderMenu pages={pages} />
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </AppBar >
            <DonateDialog open={donateOpen} handleClose={() => setDonateOpen(false)} />
        </>
    );
};

export default Header;